import React, { useEffect, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import { Tooltip } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    background: "transparent",
    borderColor: "transparent",
  },
}));
const DownloadOrderExcel = (props) => {
  const classes = useStyles();
  console.log("Download Order Excel");
  const orderData = props.order;
  let orderToDetails =
    props.order.orderType == "sales"
      ? props.order.partner
      : props.order.warehouse;
  let orderToName = orderToDetails?.name;
  let orderBarcode = props.order.order_barcode;
  orderBarcode = orderBarcode != "" ? orderBarcode.toString() : "";
  const isLoading = !orderData;
  const showData = orderData;
  const excelFilename = `order-invoice-${props.order.order_barcode}`;
  let totalAmount = 0;
  let totalGrossWeight = 0;
  let products = [];
  let pushedObjects = [];
  // let orderItems = [];
  // orderItems = [...props.order.allLoad];
  let orderItems = props.order.allLoad.map((item) => {
    return { ...item };
  });
  console.log("Before For Each");
  console.table("products");
  console.table(products);
  console.table("orderItems");
  console.table(orderItems);
  console.table("props order load");
  console.table(props.order.allLoad);
  orderItems.forEach((val) => {
    // if(val.quantity > 1) {
    //     // this is just a temporary solution
    //         // for the issue of automatically change of product quantity value in props.order.allLoad
    //     console.log("pdf val.quantity");
    //     console.log(val.quantity);
    //     val.quantity = 1;
    //     console.log(val.quantity);
    // }
    // let temp =
    //   val.price * val.quantity + (val.tax.gst / 100) * val.price * val.quantity;
    let ecomPrice = Math.floor(val.price*1.18);
      ecomPrice = ecomPrice*val.quantity;
      totalAmount += ecomPrice; 
    // totalAmount += temp - (temp / 100) * val.discount;
    let productId = val.item._id;
    if (pushedObjects.length > 0 && pushedObjects.includes(productId)) {
      //  console.log('id exist');
      var productIndex = products.findIndex(function (value) {
        return value.item._id == productId;
      });
      console.log("product index:" + productIndex);
      let currentQuantity = products[productIndex].quantity;
      products[productIndex].quantity = currentQuantity + 1;
    } else {
      // console.log('id not exist');
      pushedObjects.push(productId);
      products.push(val);
    }
  });
  totalAmount = totalAmount.toFixed(2);
  console.log("After For Each");
  console.table("products");
  console.table(products);
  console.table("props order load");
  console.table(props.order.allLoad);
  console.table("props order items");
  console.table(orderItems);
  return (
    <React.Fragment>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button"
        table="table-to-xls"
        filename={excelFilename}
        sheet="order"
        buttonText={
          <Tooltip title="Download Excel">
            <Button
              variant="contained"
              color="default"
              className={classes.button}
              startIcon={<GetAppRoundedIcon />}
            >
              Download Excel
            </Button>
          </Tooltip>
        }
      />
      <Divider />
      <table id="table-to-xls" hidden>
        <tbody>
          <tr rowSpan="2">
            <td
              colSpan="4"
              style={{ fontWeight: "bold", fontSize: "30px", color: "#dd3333" }}
            >
              ALDER
              <small style={{ marginLeft: 10, color: "#888888" }}>
                {" "}
                ISO 9001:2008 Certified
              </small>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td colSpan="5" style={{ textAlign: "center" }}>
              Alder Furniture Pvt Ltd
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td colSpan="5">
              27 Furniture Block, Kirti Nagar, New Delhi – 110015, INDIA
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td colSpan="5">
              website: www.alder.in, Email: info@alder.in | sales@alder.in
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td colSpan="5">Phone: +91-011-42903322</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>Client Name</td>
            <td colSpan="2" style={{ textAlign: "right" }}>
              {orderToName}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>Order Barcode</td>
            <td colSpan="2" style={{ textAlign: "right" }}>
              {orderBarcode + ""}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td style={{ fontWeight: "bold" }}>ORDER ESTIMATE</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <th>Sl No</th>
            <th>Item Code</th>
            <th>Item Name</th>
            <th>Order Quantity</th>
            <th>Number of Packages(parts)</th>
            <th>Total Packages</th>
            <th>Total Weight</th>
            {/* <th>Total CBM</th> */}
            <th>Unit Price (INR)</th>
            <th>Discount (%)</th>
            <th>Tax (%)</th>
            <th>Total Amount (INR)</th>
          </tr>
          {products.map((val, index) => {
            let totalWeight = 0;
            let totalCBM = 0;
            val.type == "Product" &&
              val.item &&
              val.item.productParts.map((part) => {
                totalWeight += parseInt(part.partId && part.partId.weight);
                totalCBM +=
                  part.partId &&
                  part.partId.height * part.partId &&
                  part.partId.width * part.partId &&
                  part.partId.length;
              });
            // let totalAmount =
            //   val.price * val.quantity +
            //   (val.tax.gst / 100) * val.price * val.quantity;
            let totalAmount = Math.floor(val.price*1.18);
                totalAmount = totalAmount*val.quantity;
            let totalAmountDis =
              totalAmount - (totalAmount / 100) * val.discount;
            totalGrossWeight += totalWeight * val.quantity;
            return (
              <React.Fragment>
                {val.type == "Product" && val.item && val.item != null ? (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{val.item && val.item.product_barcode}</td>
                    <td>{val.item && val.item.productName}</td>
                    <td>{val.quantity}</td>
                    <td>{val.item && val.item.productParts.length}</td>
                    <td>
                      {val.item && val.item.productParts.length * val.quantity}
                    </td>
                    <td>{totalWeight > 0 ? totalWeight * val.quantity : ""}</td>
                    {/* <td>{totalCBM > 0  ? (totalCBM*val.quantity):''}</td> */}
                    <td>{val.price}</td>
                    <td>{val.discount} %</td>
                    <td>{val.tax.gst}%</td>
                    <td>{totalAmountDis}</td>
                  </tr>
                ) : (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{val.item && val.item.parts_barcode}</td>
                    <td>{val.item && val.item.partName}</td>
                    <td>{val.quantity}</td>
                    <td>1</td>
                    <td>{val.quantity}</td>
                    <td>
                      {val.item && val.item.weight > 0
                        ? Math.round(val.item.weight * val.quantity * 100) / 100
                        : ""}
                    </td>
                    {/* <td>
                      {val.item &&
                      val.item.height * val.item.width * val.item.length > 0
                        ? val.item.height *
                          val.item.width *
                          val.item.length *
                          val.quantity
                        : ""}
                    </td> */}
                    <td>{Math.round(val.price * 100) / 100}</td>
                    <td>{val.discount} %</td>
                    <td>{val.tax.gst} %</td>
                    <td>{Math.round(totalAmountDis * 100) / 100}</td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td colSpan="2" style={{ textAlign: "center" }}>
              Total Gross Weight
            </td>
            <td>
              {totalGrossWeight > 0
                ? Math.round(totalGrossWeight * 100) / 100
                : " "}
            </td>

            <td></td>

            <td colSpan="2" style={{ textAlign: "center" }}>
              Total Amount
            </td>
            <td style={{ textAlign: "right" }}>
              {" "}
              Rs {Math.round(totalAmount * 100) / 100}
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default DownloadOrderExcel;
